module.exports = __webpack_public_path__ + "static/img/10.81908bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/eng/10.png
// module id = 9qRC
// module chunks = 0